import { SUBSCRIBE_URL, MEMBER_CENTER } from '../constants/constants-urls';

export const linksSubscribe = [
  {
    label: 'Digital access',
    link: `${SUBSCRIBE_URL}/B5242/?p1=BGFooter`,
  },
  {
    label: 'Home delivery',
    link: `${SUBSCRIBE_URL}/B3428/?p1=BGFooter`,
  },
  {
    label: 'Gift subscriptions',
    link: 'https://manage.bostonglobe.com/gift/gift.html',
  },
];

export const linksAccount = [
  {
    label: 'Manage my account',
    link: `${MEMBER_CENTER}?p1=BGFooter`,
  },
  {
    label: 'Sign up for newsletters',
    link: 'https://www.bostonglobe.com/newsletters?p1=BGFooter_Newsletters',
  },
];

export const linksContact = [
  {
    label: 'Help',
    link: 'https://customerservice.bostonglobe.com/hc/en-us?p1=BGFooter',
  },
  {
    label: 'FAQs',
    link: 'https://customerservice.bostonglobe.com/hc/en-us?p1=BGFooter',
  },
  {
    label: 'Globe newsroom',
    link: 'https://www.bostonglobe.com/tools/help/stafflist?p1=BGFooter',
  },
  {
    label: 'Advertise',
    link: 'https://www.bostonglobemedia.com/',
  },
  {
    label: 'Order back issue',
    link: 'https://payment.bostonglobe.com/back-issues',
  },
];

export const linksSocial = [
  {
    label: 'Facebook',
    link: 'https://www.facebook.com/globe',
  },
  {
    label: 'Twitter',
    link: 'https://twitter.com/#!/BostonGlobe',
  },
  {
    label: 'Google+',
    link: 'https://plus.google.com/108227564341535363126/about',
  },
];

export const linksMore = [
  {
    label: 'ePaper',
    link: 'https://epaper.bostonglobe.com/launch.aspx?pbid=2c60291d-c20c-4780-9829-b3d9a12687cf',
  },
  {
    label: 'News in education',
    link: 'http://nieonline.com/bostonglobe/',
  },
  {
    label: 'Archives',
    link: 'https://bostonglobe.newspapers.com/?xid=1880&tpa=42lr6N3zsc+dBUt8uGaKuw==&cj_pub_cid=5109105&cj_pub_name=Boston+Globe+Media+Partners&cj_pub_site_id=8819575&cj_link_id=11570746&cj_pub_sid=&cjevent=6345ee789ba211ef8152943b0a82b820',
  },
  {
    label: 'Privacy Policy',
    link: 'https://www.bostonglobe.com/about/help/privacy-policy/?p1=BGFooter',
  },
  {
    label: 'Terms of service',
    link: 'https://www.bostonglobe.com/about/help/terms-service/?p1=BGFooter',
  },
  {
    label: 'Terms of purchase',
    link: 'https://www.bostonglobe.com/about/help/terms-purchase/?p1=BGFooter',
  },
  {
    label: 'Work at Boston Globe Media',
    link: 'https://www.bostonglobemedia.com/careers',
  },
];
